import request from '@/utils/request'

// 店铺经营类目查询接口
export function getQryCate(data) {
  return request({
    url: '/apis/sra/store/users/signup/qryCate', // 后端接口
    method: 'post',
    data
  })
}
